import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './defines/baseQueryReAuth';
import { mainServiceURL } from './defines';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    login: builder.mutation<any, { email: string; password: string; rememberMe: boolean }>({
      query: (credentials) => ({
        url: `${mainServiceURL}/login/native`,
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<any, { email: string; password: string; companyID?: string }>({
      query: (data) => ({
        url: `${mainServiceURL}/signUp/native`,
        method: 'POST',
        body: data,
      }),
    }),
    verifyToken: builder.query<any, void>({
      query: () => ({ url: `${mainServiceURL}/auth/verify`, method: 'GET' }),
      keepUnusedDataFor: 0,
    }),
    getAuthMode: builder.query<any, void>({
      query: () => ({ url: `${mainServiceURL}/auth/mode`, method: 'GET' }),
      keepUnusedDataFor: 300,
    }),
    logout: builder.mutation<void, void>({
      query: () => ({ url: `${mainServiceURL}/logout/native`, method: 'GET' }),
    }),
    requestPasswordReset: builder.mutation<any, { email: string }>({
      query: (data) => ({
        url: `${mainServiceURL}/login/native/password-recovery`,
        method: 'POST',
        body: data,
      }),
    }),
    resetPassword: builder.mutation<any, { password: string; token: string }>({
      query: (data) => ({
        url: `${mainServiceURL}/login/native/password-reset`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyTokenQuery,
  useGetAuthModeQuery,
  useLogoutMutation,
  useRequestPasswordResetMutation,
  useResetPasswordMutation,
} = authApi;
